// Infinite scroll pentru colecții (înlocuiește paginarea).
// Citește pagina următoare din linkul de paginare, adaugă produsele în grilă.
(function () {
  function init() {
    const grid = document.getElementById('product-grid');
    if (!grid || grid.dataset.infiniteInit) return;
    grid.dataset.infiniteInit = '1';

    const wrapper = grid.closest('.collection') || grid.parentElement;
    const paginationWrapper = wrapper.querySelector('.pagination-wrapper');

    // URL-ul paginii următoare (din linkul "next" sau construit din ?page=)
    function nextUrlFrom(doc) {
      const root = doc || document;
      const nextLink = root.querySelector(
        '.pagination__item--prev ~ .pagination__item[href], a.pagination__item[aria-label*="Next"], a.pagination__item[aria-label*="următor"], .pagination__item[rel="next"]'
      );
      if (nextLink && nextLink.getAttribute('href')) return nextLink.getAttribute('href');

      // Fallback: incrementează ?page=
      const here = (root === document) ? location.href : null;
      return here ? bumpPage(here) : null;
    }

    function bumpPage(href) {
      const url = new URL(href, location.origin);
      const cur = parseInt(url.searchParams.get('page') || '1', 10);
      url.searchParams.set('page', cur + 1);
      return url.pathname + url.search;
    }

    let nextUrl = nextUrlFrom(document) ? bumpPage(location.href) : null;
    // Dacă nu există paginare, nu activăm.
    if (!paginationWrapper) return;
    if (paginationWrapper) paginationWrapper.setAttribute('data-infinite-hidden', '');

    // pornește mereu de la pagina următoare celei curente
    const startUrl = new URL(location.href);
    const curPage = parseInt(startUrl.searchParams.get('page') || '1', 10);
    startUrl.searchParams.set('page', curPage + 1);
    nextUrl = startUrl.pathname + startUrl.search;

    // Loader + sentinel
    const loader = document.createElement('div');
    loader.className = 'infinite-loader';
    loader.innerHTML = '<span class="infinite-loader__spinner" role="status" aria-label="Se încarcă"></span>';
    wrapper.appendChild(loader);

    let loading = false;
    let done = false;

    async function loadMore() {
      if (loading || done || !nextUrl) return;
      loading = true;
      loader.setAttribute('aria-busy', 'true');

      try {
        const res = await fetch(nextUrl);
        if (!res.ok) { done = true; return; }
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = doc.querySelectorAll('#product-grid > li.grid__item');

        if (!items.length) { done = true; loader.remove(); return; }

        items.forEach((li) => grid.appendChild(document.importNode(li, true)));

        // pagina următoare
        const url = new URL(nextUrl, location.origin);
        const p = parseInt(url.searchParams.get('page') || '2', 10);
        url.searchParams.set('page', p + 1);
        nextUrl = url.pathname + url.search;

        // dacă pagina avea mai puține produse decât o pagină plină, oprește după
        const fullPage = doc.querySelectorAll('#product-grid > li.grid__item').length;
        if (fullPage === 0) done = true;
      } catch (e) {
        done = true;
      } finally {
        loading = false;
        loader.removeAttribute('aria-busy');
        if (done) loader.remove();
      }
    }

    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) loadMore();
    }, { rootMargin: '600px 0px' });

    io.observe(loader);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
